import React, { useState } from "react";
import { fetchAuthSession } from "aws-amplify/auth";
import { useNavigate } from "react-router-dom";
import { ReactComponent as ErodeLogo } from "../assets/icons/erode-logo-white.svg";
import Pattern from "../assets/images/bg-pattern-01.svg";

const NotFound = () => {
  const navigate = useNavigate();
  const [isNavigating, setIsNavigating] = useState(false);

  // Function to handle navigation based on authentication status. If user is authenticated, navigate to /home, else navigate to / to go to landing page.
  const handleBackNavigation = async () => {
    if (isNavigating) return;
    setIsNavigating(true);
    try {
      const authSession = await fetchAuthSession();
      const isAuthenticated = Boolean(authSession?.tokens?.idToken);
      navigate(isAuthenticated ? "/home" : "/");
    } catch (error) {
      console.error("Error checking authentication session", error);
      navigate("/");
    } finally {
      setIsNavigating(false);
    }
  };

  return (
    <div className="min-h-screen bg-slate-950 text-white">
      <div className="absolute inset-0 bg-gradient-to-br from-slate-950 via-slate-900 to-white/25" />
      <div
        className="absolute inset-0 opacity-30"
        style={{
          backgroundImage: `url(${Pattern})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          backgroundAttachment: "fixed",
        }}
      />
      <div className="relative mx-auto flex min-h-screen max-w-5xl flex-col items-center justify-center px-6 py-16 font-Inter">
        <div className="flex items-center gap-3 text-sm uppercase tracking-[0.4em] text-emerald-300/80">
          <span className="h-2 w-2 rounded-full bg-emerald-300/80" />
          Erode AI
        </div>
        <div className="mt-6 flex items-center justify-center">
          <div className="flex h-16 w-16 items-center justify-center rounded-2xl border border-emerald-300/20 bg-emerald-400/10 shadow-[0_0_30px_rgba(16,185,129,0.2)]">
            <ErodeLogo className="h-10 w-10" />
          </div>
        </div>
        <div className="mt-8 text-center">
          <div className="text-[clamp(3.5rem,12vw,10rem)] font-semibold leading-none text-white">
            404
          </div>
          <div className="mt-4 text-2xl font-semibold text-white sm:text-3xl">
            Page not found
          </div>
          <p className="mt-3 max-w-xl text-base text-slate-300 sm:text-lg">
            The link might be broken, or the page has moved. Let's get you back
            to somewhere familiar.
          </p>
        </div>
        <div className="mt-10 flex w-full flex-col gap-3 sm:w-auto sm:flex-row">
          <button
            className="eai-btn-grn px-6 py-3 text-center"
            type="button"
            onClick={handleBackNavigation}
            disabled={isNavigating}
          >
            {isNavigating ? "Navigating..." : "Back to home"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
